var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Pricing"},[_c('MobileNav',{attrs:{"page_title":_vm.nav_title}}),_c('div',{staticClass:"pricing-details-container"},[_c('PricingComponent')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }